import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { ApiClientService } from './api-client.service';
import { BaseService } from './base.service';
import { IRefreshTokenResponse } from '../interfaces/login.interface';
import { StandardApiResponse } from '../interfaces/standard-api-response.interface';
import { TokenStorageService } from './token-storage.service';

@Injectable({ providedIn: 'root' })
export class TokenRefreshService extends BaseService {
  private readonly tokenStorage = inject(TokenStorageService);
  private refreshInFlight: Observable<StandardApiResponse<IRefreshTokenResponse>> | null = null;

  constructor() {
    super(inject(ApiClientService));
  }

  refresh(): Observable<StandardApiResponse<IRefreshTokenResponse>> {
    if (this.refreshInFlight) {
      return this.refreshInFlight;
    }

    const refreshToken = this.tokenStorage.getRefreshToken();

    this.refreshInFlight = this.api
      .post<StandardApiResponse<IRefreshTokenResponse>>(this.buildUrl('/auth/refresh'), { refreshToken })
      .pipe(shareReplay({ bufferSize: 1, refCount: true }));

    return this.refreshInFlight;
  }

  clearInFlight(): void {
    this.refreshInFlight = null;
  }
}
